var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 21.9938C17.5184 21.9938 21.9943 17.5179 21.9943 11.9966C21.9943 6.47538 17.5184 1.99951 11.9971 1.99951C6.47587 1.99951 2 6.47538 2 11.9966C2 17.5179 6.47587 21.9938 11.9971 21.9938Z",
    stroke: "#EA6C52",
    strokeWidth: 1.99943
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 5.99805V11.9963L15.9949 13.9957",
    stroke: "#EA6C52",
    strokeWidth: 1.99943
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.b8444b50b3aa1a0c6fe0f6c1dd62b0ca.svg";
export { ForwardRef as ReactComponent };